import type { FunctionComponent, ReactNode } from 'react';

import LabeledRadio from './LabeledRadio';
import TextInput from './TextInput';

import styles from './LabeledRadioWithInput.module.less';

type LabeledRadioWithInputProps = {
  label: ReactNode;
  value: string;
  isChecked: boolean;
  inputValue: string;
  onInputChange: (value: string) => void;
  inputAriaLabel?: string;
  inputPlaceholder?: string;
  inputSize?: 'small' | 'medium' | 'large';
  isDisabled?: boolean;
};

/**
 * A radio whose label morphs into an inline text input when the radio is
 * checked. Pairs with `LabeledRadio` inside a `<RadioGroup>` for the
 * "Other: ___" pattern.
 */
const LabeledRadioWithInput: FunctionComponent<LabeledRadioWithInputProps> = ({
  label,
  value,
  isChecked,
  inputValue,
  onInputChange,
  inputAriaLabel = 'Open response',
  inputPlaceholder,
  inputSize = 'medium',
  isDisabled,
}) => (
  <LabeledRadio
    value={value}
    isDisabled={isDisabled}
    label={
      isChecked ? (
        <span className={styles.openLabel}>
          <span className={styles.staticLabel}>{label}:</span>
          <span
            role="presentation"
            className={styles.inputWrapper}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <TextInput
              label={inputAriaLabel}
              value={inputValue}
              onChange={onInputChange}
              placeholder={inputPlaceholder}
              isDisabled={isDisabled}
              size={inputSize}
              variant="underlined"
              autoFocus
            />
          </span>
        </span>
      ) : (
        label
      )
    }
  />
);

export default LabeledRadioWithInput;
